import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { BreadcrumbType } from "src/components/Breadcrumb/Breadcrumbs";

export type ElementType = "headings" | "subheadings" | "properties" | "subproperties" | "lca" | "component";
export type DrilldownState = {
    id: number;
    type: ElementType;
    label: string;
    extraAction?: () => void;
};

type DrilldownInitOptions = {
    goBackLink: string;
    title: string;
};

export type Drilldown = {
    breadcrumbs: BreadcrumbType[];
    drilldown: (item: DrilldownState) => void;
    state: DrilldownState[];
    reset: () => void;
};
export const useDrilldown = (options: DrilldownInitOptions) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { goBackLink, title } = options;

    const initItems: BreadcrumbType[] = [
        {
            label: t("breadcrumbs.scores_and_indicators"),
            action: () => {
                navigate(goBackLink);
            },
        },
        {
            label: title,
            action: () => {
                reset();
            },
        },
    ];
    const startingLengthPosition = initItems.length;

    const [breadcrumbs, _setBreadcrumbs] = useState<BreadcrumbType[]>(initItems);
    const [state, _setDrilldownState] = useState<DrilldownState[]>([]);

    const drilldown = (item: DrilldownState) => {
        const newBreadcrumb: BreadcrumbType = {
            label: item.label,
            action: () => {
                const newItemPos = breadcrumbs.length + 1;
                item.extraAction?.();
                _setDrilldownState((prev) => {
                    const newDrilldownState = prev.slice(0, newItemPos - startingLengthPosition);
                    return newDrilldownState;
                });
                _setBreadcrumbs((prev) => {
                    const newItems = prev.slice(0, newItemPos);
                    return newItems;
                });
            },
        };

        _setDrilldownState([...state, item]);
        _setBreadcrumbs([...breadcrumbs, newBreadcrumb]);
    };

    const reset = () => {
        _setBreadcrumbs(initItems);
        _setDrilldownState([]);
    };

    return { breadcrumbs, drilldown, state, reset };
};
